import { render, staticRenderFns } from "./TabSecurity.vue?vue&type=template&id=f1dbdeb8&scoped=true"
import script from "./TabSecurity.vue?vue&type=script&lang=ts"
export * from "./TabSecurity.vue?vue&type=script&lang=ts"
import style0 from "./TabSecurity.vue?vue&type=style&index=0&id=f1dbdeb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dbdeb8",
  null
  
)

export default component.exports